import type { ReviewHistoryEntry, ReviewRating } from '../types/api.types';

export interface ReviewIntervalPoint {
  review: number; // 1-based review number
  days: number; // elapsed days since the previous review (or since the word was added)
  rating: ReviewRating;
}

const MS_PER_DAY = 86_400_000;

// A log axis cannot show 0, so same-day repeats are clamped to this floor.
export const MIN_INTERVAL_DAYS = 0.5;

/**
 * Days elapsed before each review. Review 1 is measured from when the word was added;
 * every later review from the one before it.
 */
export function computeReviewIntervals(
  createdAt: string,
  history: ReviewHistoryEntry[],
): ReviewIntervalPoint[] {
  let previous = new Date(createdAt).getTime();
  return history.map((entry, i) => {
    const at = new Date(entry.reviewedAt).getTime();
    const days = Number.isFinite(previous) && Number.isFinite(at) ? (at - previous) / MS_PER_DAY : MIN_INTERVAL_DAYS;
    previous = at;
    return { review: i + 1, days: Math.max(MIN_INTERVAL_DAYS, days), rating: entry.rating };
  });
}
